<template>
   <div>
     <!-- 主体内容 -->
    <el-row>
      <!-- title -->
      <div class="modt-box">套餐管理</div>
      <el-col :span="4" class="btn"> 
        <el-button type="primary" @click="addMeal">新增</el-button> 
        </el-col>

        <el-table size="small" :data="listData" highlight-current-row   border element-loading-text="拼命加载中" style="width: 100%;">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column sortable   align="center" prop="p_id" label="项目名称" width="100">
      </el-table-column>
      <el-table-column sortable   align="center" prop="name" label="套餐" width="150">
      </el-table-column>

         <el-table-column sortable   align="center" prop="product_id" label="产品ID" width="150">
      </el-table-column>
       <el-table-column sortable   align="center" prop="sku_id" label="套餐ID" width="150">
      </el-table-column>
        <el-table-column sortable align="center" prop="status" label="状态" width="80">
          <template slot-scope="scope">
        <el-tag
          :type="statusStyle(scope.row.status)"
          disable-transitions>{{StateToStr(scope.row.status)}}</el-tag>
      </template>
      </el-table-column>
        <el-table-column sortable  align="center" prop="create_time" label="创建时间" width="150">
      </el-table-column>
        <el-table-column sortable  align="center" prop="update_time" label="更新时间" width="150">
      </el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="editModule(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delMeal(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
      <el-pagination
  background
  layout="prev, pager, next"
  :total="total"
  @current-change="handleCurrentChange">
</el-pagination>
      <el-col :span="18">
        <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
        width="30%"
       @click="dialogClose">
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="项目名称" prop="p_id">
            <el-select v-model="form.p_id" placeholder="请选择项目名称"  @change="clearName">
            <el-option  v-for="items,i in  productName"  :key="i" :label="items.name" :value="items.id"></el-option>
     
        </el-select>
            
          </el-form-item>
          <el-form-item label="套餐" prop="name"> 
              <el-input size="small" v-model="form.name"></el-input>
          </el-form-item>
            <el-form-item label="三方产品ID" prop="product_id"> 
              <el-input size="small" v-model="form.product_id"></el-input>
          </el-form-item>
            <el-form-item label="三方套餐ID" prop="sku_id"> 
              <el-input size="small" v-model="form.sku_id"></el-input>
          </el-form-item>
          <el-form-item label="生效" prop="status">
         <el-switch
              v-model="form.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="active_value"
              :inactive-value="inactive_value">
                </el-switch>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  v-show="addshow" @click="saveModule('form')">保存</el-button>  
          </el-form-item>
        </el-form>
         </el-dialog>
      </el-col>
     

    </el-row>
    </div>   


</template>

<script>

import {ProductList,meal_list,addMeal,saveMeal,editMeal ,delMeal,updateMeal} from '@/api/userFun'
export default {
 
    data(){
        return{
            act:'add',
            pageparm: {
            currentPage: 1,
            pageSize: 10,
            total: 0,
           },
            total:0,
            active_value:1,
            inactive_value:0,
            productName:[

            ],
            form:{
              name:'',
              p_id:0,
              sku_id:'',
              product_id:''

            },
            addshow:true,
           
            dialogVisible:false,
            showdelete:false,
            checkedId:'',
            form: {
             status:1,
             name:'',
             p_id:'',
             },
             listData:[],
             
              // rules表单验证
            rules: {
                
                name: [
                { required: true, message: '请输入套餐名称', trigger: 'blur' }
                ],
                p_id: [
                { required: true, message: '请选择项目名称', trigger: 'blur' }
                ],
            },
        }
    },
    created(){
      ProductList().then(res=>{
      //  console.log(res.data);
        let ProductList=[];
          res.data.forEach(element => {
            let arr=[];
             arr['id']=element['id'];
              arr['name']=element['name'];
            ProductList.push(arr);
          });
        this.productName=ProductList
          //console.log(ProductList);
      })
       this.getdata(this.pageparm);
    },
   methods: {
    handleCurrentChange(currentPage){
      this.pageparm.currentPage=currentPage;
      this.getdata(this.pageparm)
    },
    dialogClose(){
      this.dialogVisible=true;
      this.form.name="";
    },
    addMeal(){
      this.dialogVisible=true;
    },

   handleCheckedCitiesChange(value) {

        console.log(value);
        let checkedCount = value.length;
       // this.checkAll = checkedCount === this.cities.length;
       // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      },
    getdata(pram){
        meal_list(pram).then(res=>{
            this.$nextTick(()=>{
              this.listData=res.data.data;
              this.total=res.data.total;
            });
                
        })
    },
   
    clearName(){

      this.form.name="";
     
    },

     clearForm(form){
      //  this.$refs[form].resetFields();
        this.form.name="";
         this.form.p_id="";
        //this.form.rules="";
        this.dialogVisible=false;
        if(this.form.hasOwnProperty('id')){
            delete this.form.id;
        }

     },  
    
    // 保存菜单
    saveModule(editData) {
     
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.act=='update'){
             console.log(this.form);
            updateMeal(this.form).then(res=>{
                   this.act='';
                    this.clearForm('form');
                    this.getdata(this.pageparm);
                });
              return;
          }
          addMeal(this.form)
            .then(res => {
            // this.dialogClose();
              this.getdata(this.pageparm);
              this.clearForm('form');
             // console.log(this.form);
            //   this.getmenu()
            })
        } else {
          return false
        }
      })
    },
    // 删除菜单
    delMeal(index,row) {
      let deleteId={
        id:row['id'],
        };
      delMeal(deleteId)
        .then(res => {
          this.getdata(this.pageparm)
         this. clearForm('form');
          this.$message.error('删除成功！')
        })
    },

     // 编辑套餐
    editModule(index,row) {
      let editId={
        id:row['id'],
        };
        this.act='update';
      editMeal(editId)
        .then(res => {
          this.$nextTick(()=>{
            this.form=res.data
          });
          
          this.dialogVisible=true;
          //this. clearForm('form');
         // this.$message.error('菜单管理列表删除成功！')
        })
    },


     statusStyle(status){
      if(status==1){
        return 'success';
      }else if(status==0){
          return 'info';
      }else{
        return 'danger';
      }
      
    },
    StateToStr(status){
      if(status==1){
        return '生效';
      }else if(status==0){
        return '无效';
      }
      else{
        return '未知状态';
      }
    }, 
  
   },

}
</script>
<style>
.btn{
  margin-bottom: 1.58rem;
}
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/system/meal.vue